import { notFound } from 'next/navigation'
import { getRequestConfig } from 'next-intl/server'

export enum LocaleEnum {
  EN = 'en',
  ES = 'es',
  PT = 'pt',
}

export const defaultLocale = LocaleEnum.EN

export const locales = [LocaleEnum.EN, LocaleEnum.ES, LocaleEnum.PT] as const

export default getRequestConfig(async ({ requestLocale }) => {
  const locale = await requestLocale

  if (!locale || !locales.includes(locale as LocaleEnum)) {
    notFound()
  }

  return {
    locale,
    messages: (await import(`../../app/translation/${locale}.json`)).default,
  }
})
